import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Types
import Reducers from "types/Reducers";
// Async
import { getQuiz } from './quizAsync';

interface IState {
  quiz: any;
  questions: any[];
  interstitialImages: any[];
  preQuizQuestionsAnswers: any;
};

const initialState:IState = {
  quiz: null,
  questions: [],
  interstitialImages: [],
  preQuizQuestionsAnswers: null
};

const slice = createSlice({
  name: Reducers.Quiz,
  initialState,
  reducers: {
    setQuiz: (state, action:PayloadAction<any>) => {
      const quiz = action.payload;

      let questions = quiz.questions;
      let interstitialImages = [];

      if ( quiz.randomizeQuestionOrder ){
        questions = questions.sort(() => Math.random() - 0.5);
      }
      if ( quiz.questionLimit && quiz.questionLimit > 0 ){
        questions = questions.slice(0, quiz.questionLimit);
      }
      if ( quiz.interstitialImageUrl ) interstitialImages.push(quiz.interstitialImageUrl);
      if ( quiz.interstitialImageUrl2 ) interstitialImages.push(quiz.interstitialImageUrl2)

      state.quiz = quiz;
      state.questions = questions;
      state.interstitialImages = interstitialImages;
    },
    setPreQuizQuestionsAnswers: (state: IState, action) => {
      state.preQuizQuestionsAnswers = action.payload;
    }
  },
  extraReducers(builder) {
    // Get quiz
    builder.addCase(getQuiz.pending, (state) => {
      state.quiz = null;
      state.questions = []
    });
    builder.addCase(getQuiz.fulfilled, (state, action:PayloadAction<any>) => {
      const quiz = action.payload;

      let questions = quiz.questions;
      let interstitialImages = [];

      if ( quiz.randomizeQuestionOrder ){
        questions = questions.sort(() => Math.random() - 0.5);
      }
      if ( quiz.questionLimit && quiz.questionLimit > 0 ){
        questions = questions.slice(0, quiz.questionLimit);
      }
      if ( quiz.interstitialImageUrl ) interstitialImages.push(quiz.interstitialImageUrl);
      if ( quiz.interstitialImageUrl2 ) interstitialImages.push(quiz.interstitialImageUrl2)

      state.quiz = quiz;
      state.questions = questions;
      state.interstitialImages = interstitialImages;
    });
    builder.addCase(getQuiz.rejected, (state) => {
      state.quiz = undefined;
      state.questions = [];
      state.interstitialImages = [];
    });
  }
});

export const { setQuiz, setPreQuizQuestionsAnswers } = slice.actions;

export default slice.reducer;
